import type { InteractionNotification } from '@/apis/business/agent/callLogs/types';

export function mergeNotificationLogs(
  emailLogs: InteractionNotification[] = [],
  smsLogs: InteractionNotification[] = []
): InteractionNotification[] {
  return [...emailLogs, ...smsLogs].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
}
